var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO001Power(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6001 9.60001H11.4001V1.20001H12.6001V9.60001ZM13.8019 3.79861V5.03761C16.9015 5.84041 19.2001 8.65321 19.2001 12C19.2001 15.9702 15.9703 19.2 12.0001 19.2C8.0299 19.2 4.8001 15.9702 4.8001 12C4.8001 8.65201 7.1005 5.83801 10.2019 5.03641V3.79801C6.4279 4.62181 3.6001 7.97881 3.6001 12C3.6001 16.6392 7.3609 20.4 12.0001 20.4C16.6393 20.4 20.4001 16.6392 20.4001 12C20.4001 7.98001 17.5741 4.62421 13.8019 3.79861Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO001Power);
export default __webpack_public_path__ + "static/media/O001 - Power.6b605c4306a797e136fb4eaf0aa0b1cc.svg";
export { ForwardRef as ReactComponent };